import constConf from '../../../constconf'

export default {
    last20: (context, payload) => {
        let url = constConf.message.url + '/file-bind/all/' + payload.model.bot_id
        return context.dispatch('axios/queryWithData', { method: 'post', url: url, data: payload }, { root: true })
            .then(response => {
                return response
            })
    },
    lastDialogs: (context, payload) => {
        context.commit('lastDialogs', [])
        let url = constConf.message.url + '/message-dialog/last-dialogs/' + payload
        return context.dispatch('axios/queryWithData', { method: 'post', url: url, data: payload }, { root: true })
            .then(response => {
                if (response.ok) {
                    context.commit('lastDialogs', response.response.data)
                }
                return response
            })
    },
    loadMessagesChat: (context, payload) => {
        context.commit('loadMessagesChat', [])
        let url = constConf.message.url + '/message-dialog/load-messages-chat/' + payload.bot_id
        return context.dispatch('axios/queryWithData', { method: 'post', url: url, data: payload }, { root: true })
            .then(response => {
                if (response.ok) {
                    context.commit('loadMessagesChat', response.response.data)
                }
                return response
            })
    }
}
